module.exports = __webpack_public_path__ + "img/comment-dollar.75b09364.svg";